export function safeContains(item, substring, key) {
  const value = typeof key === 'function' ? key(item) : item[key || 'name']
  const safeSubstring = substring ? substring.toLowerCase() : ''
  return String(value).toLowerCase().indexOf(safeSubstring) > -1
}

export function getAttribute(item, attributeName, defaultValue) {
  return item === undefined || item[attributeName] === undefined
    ? defaultValue
    : item[attributeName]
}
